import { create } from 'zustand';
import type { BuildingForRender, RoadForRender } from '../hooks/useCityData';

interface CityState {
  buildings: BuildingForRender[];
  roads: RoadForRender[];
  selectedObject: BuildingForRender | null;
  setBuildings: (buildings: BuildingForRender[]) => void;
  setRoads: (roads: RoadForRender[]) => void;
  selectObject: (obj: BuildingForRender | null) => void;
  updateBuildingProperty: (id: number | string, key: string, value: unknown) => void;
  removeBuilding: (id: number | string) => void;
}

export const useCityStore = create<CityState>((set) => ({
  buildings: [],
  roads: [],
  selectedObject: null,
  setBuildings: (buildings) => set({ buildings }),
  setRoads: (roads) => set({ roads }),
  selectObject: (obj) => set({ selectedObject: obj }),
  updateBuildingProperty: (id, key, value) =>
    set((state) => ({
      buildings: state.buildings.map((b) =>
        b.id === id ? { ...b, [key]: value } : b
      ),
    })),
  removeBuilding: (id) =>
    set((state) => ({
      buildings: state.buildings.filter((b) => b.id !== id),
      selectedObject: state.selectedObject?.id === id ? null : state.selectedObject,
    })),
}));